import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UseAuth, hasValidAuthSession } from 'src/auth/AuthContext';
import Layout from 'src/Layouts/Main';

interface GuardProps {
  children: ReactNode;
}

const GuardClient: FC<GuardProps> = ({ children }) => {
  const { isAuthenticated } = UseAuth();

  if (!isAuthenticated || !hasValidAuthSession()) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout><>{children}</></Layout>
  )
}

GuardClient.propTypes = {
  children: PropTypes.node as any
};

export default GuardClient